import { bytes_to_hex, HmacSha256, string_to_bytes } from 'asmcrypto.js'
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid'
import { ACCOUNT_INTERCEPT_ERROR_CODE, X_SOURCES_MAP } from './contansts'

import { t } from './i18n/t.js'
import {
  isDeviceMobile,
  isHLApp,
  isTHSApp,
  isTHSI18NApp,
  isTHSPC,
  isWangTing,
  isCMHK,
} from '@fs/utils'

// 从本地代理文件获取请求路由
const getLocalProxyHost = (config = {}, proxyConfig) => {
  const serveName = Object.keys(proxyConfig).find((key) => {
    const serveKey = config.url.split('/')[1]
    return key === `/${serveKey}`
  })
  let targetUrl = proxyConfig[serveName]?.target ?? ''
  if (targetUrl.slice(-1) === '/') {
    targetUrl = targetUrl.substring(0, targetUrl.length - 1)
  }

  return targetUrl.split('//')[1]?.split(':')[0] ?? ''
}

/**
 * @获取消息签名
 * 技术规范： https://www.tapd.cn/60236733/markdown_wikis/show/#1160236733001000140@toc17
 */
export const getX_sign = (config = {}, proxyConfig) => {
  try {
    let schema, host, port, path
    const h = config.headers
    // 区分是否设置baseUrl，当前未设置
    if (!config.baseURL || config.baseURL === '/') {
      // 请求协议 - 当前固定https
      // schema = location.protocol.split(':')[0]
      schema = 'https'

      // 本地调试环境、部署环境处理
      if (import.meta.env.DEV && proxyConfig) {
        host = getLocalProxyHost(config, proxyConfig)
      } else {
        host = config.url?.split('//')[1].split('/')[0]
      }

      // 请求端口 - 当前无需包含端口信息
      // port = schema === 'http' ? '80' : '443'
      port = ''

      // 请求uri
      path = (host ? (config.url.split(host)[1] ?? config.url) : config.url).split('?')[0]
    } else {
      schema = config.baseURL.split(':')[0]
      host = config.baseURL.split('//')[1].split(':')[0]
      port = config.baseURL.split('//')[1].split(':')[1] ?? ''
      path = config.url.split('?')[0]
    }

    // query参数处理
    const query = { ...config.params }
    const _queryArray = (config.url.split('?')[1] || '').split('&').filter((item) => item)
    _queryArray.forEach((item) => {
      query[item.split('=')[0]] = item.split('=')[1]
    })
    const _queryKeySorted = Object.keys(query).sort((a, b) => a.localeCompare(b))
    let query_string = ''
    for (const item of _queryKeySorted) {
      query_string += `&${item}=${query[item]}`
    }
    query_string = encodeURIComponent(decodeURIComponent(query_string.slice(1)))

    // 签名原文
    const headerKeys = [
      'X-uin',
      'X-request-id',
      'X-timestamp',
      'X-device-info',
      'X-lang',
      'X-product',
      'X-antispams',
      'X-session',
      'Content-Type:application/json',
      'X-source',
    ]
    let sign = `${config.method.toUpperCase()}${schema}${port ? host + ':' + port : host}${path}${query_string}${headerKeys
      .map((key) => {
        const [k, defaultVal = ''] = key.split(':')
        return h[k] || defaultVal
      })
      .join('')}`

    // 加密签名
    const hmacSha256 = new HmacSha256(string_to_bytes(localStorage.getItem('rndKey')))
    sign = bytes_to_hex(hmacSha256.process(string_to_bytes(sign)).finish().result)

    return sign
  } catch (err) {
    console.log('🚀 ~ x-sign err: ', err)
    return ''
  }
}

// //生成随机数代码
// const getArrayRound = (length = 12) => {
//     let arr = [];
//     for (let i = 0; i < length; i++) {
//         const randomNum6 = Math.round(Math.random() * 128)
//         arr.push(randomNum6)
//     }
//     return arr
// }

// /**
//  * //AES-GCM-256 加密函数
//  */
// export function Encrypt(word, key) {
//     let text = string_to_bytes(word, true)
//     let nonce = new Uint8Array(getArrayRound())

//     let encText = AES_GCM.encrypt(text, key, nonce)
//     console.log(text, nonce, key, encText)

//    // return bytes_to_base64(new Uint8Array(Array.from(nonce).concat(Array.from(encText))))
// }

/**
 * 是否是字符串
 * @param {*} o
 */
export const isString = (o) => {
  return Object.prototype.toString.call(o).slice(8, -1) === 'String'
}

/**
 * 转换公私钥为标准pem格式
 * @param {string} str
 * @returns string
 */
export const formatAsPem = (str) => {
  var typeString = 'PUBLIC KEY'
  var finalString = '-----BEGIN ' + typeString + '-----\n'
  while (str.length > 0) {
    finalString += str.substring(0, 64) + '\n'
    str = str.substring(64)
  }
  finalString = finalString + '-----END ' + typeString + '-----'
  return finalString
}

/**
 * 创建uuid5
 * @param {string} uin
 * @returns string
 */
export const createUUID = (uin = '') => {
  return uuidv5(uin + new Date().valueOf() + '', uuidv4())
    .split('-')
    .join('')
}

// 差异配置
export const DiffConfig = {
  default: {
    sessionKey: 'session',
  },
  signature: {
    sessionKey: 'sessionTemp',
  },
}
export const getDiffConfig = (proj = 'default') => {
  return DiffConfig[proj] ?? DiffConfig.default
}

// 冻结账户拦截 - http
export const checkFreeze = (response) => {
  const { data: resData, config } = response

  const { error } = resData
  const showFreeze = config.showFreeze ?? true

  if (showFreeze && ACCOUNT_INTERCEPT_ERROR_CODE.includes(error?.code)) {
    console.log('🚀 ~ freezeError:', error)

    // const store = (await import('@/store/index'))?.default
    // store.commit('user/updateShowLoading', false)

    const errorText = t('tradeDialog.toastFreezeText')
    const showFreezeToast = config.showFreezeToast ?? true
    if (showFreezeToast) {
      invokeToast(errorText)
    }

    // 原始Error, 方便抛出查看
    resData.originError = { ...error }

    // 设置文案
    if (error.data) {
      error.data.tips = errorText
    } else {
      error.data = { tips: errorText }
    }

    return resData
  }
}

// 冻结账户拦截 - acctStatus
export const AcctStatusMap = {
  OPENED: 1,
  CLOSED: 2,
  SUPBEND: 3,
  UNACTIVE: 4,
}
export const checkAccountStatus = ({ userDetail, message, showToast = true }) => {
  const { clientInfo: { accts: [acct = {}] = [] } = {} } = userDetail || {}
  const isSupend = acct.acctStatus !== AcctStatusMap.OPENED

  if (isSupend && showToast) {
    invokeToast(message ?? t('tradeDialog.toastFreezeText'))
  }

  return !isSupend
}

// 根据环境来区分x-source值
export function getXSource() {
  let ret = isDeviceMobile() ? X_SOURCES_MAP.HLAPP_MOBILE : X_SOURCES_MAP.HLAPP_WEB
  if (isCMHK()) {
    ret = X_SOURCES_MAP.MYLINK_APP
  } else if (isHLApp()) {
    ret = X_SOURCES_MAP.HLAPP
  } else if (isTHSApp()) {
    ret = X_SOURCES_MAP.THS_APP
  } else if (isWangTing()) {
    ret = X_SOURCES_MAP.WANG_TING
  } else if (isTHSI18NApp()) {
    ret = X_SOURCES_MAP.THS_I18N_APP
  } else if (isTHSPC()) {
    ret = X_SOURCES_MAP.THS_PC
  }
  return ret
}

let logoutInstance = null
export const getLogoutInstance = () => {
  return logoutInstance
}

export const registerLogout = (instance) => {
  logoutInstance = instance
}

/**
 * 与 Vant Toast 一致：支持字符串或配置对象（如 forbidClick、message、onClose）
 * @type {((payload: string | Record<string, unknown>) => unknown) | null}
 */
let toastInstance = null

/**
 * 注册 Toast 展示函数（与 registerLogout 用法一致，在应用入口调用一次）
 * 例如 Vant2: registerToast((p) => Toast(p))；Vant4: registerToast((p) => showToast(p))
 */
export const registerToast = (instance) => {
  toastInstance = typeof instance === 'function' ? instance : null
}

export const invokeToast = (payload) => {
  if (typeof toastInstance === 'function') {
    try {
      toastInstance(payload)
    } catch (e) {
      console.error('[@repo/http] invokeToast error:', e)
    }
  }
}
